<script setup lang="ts">
defineProps<{
	name: string;
	rgbColorValue?: string | null;
}>();
</script>

<template>
	<v-chip :color="rgbColorValue ?? undefined" size="x-small">
		{{ name }}
	</v-chip>
</template>

<style scoped lang="scss">
.v-chip {
	padding: 0 6px;
	max-width: 10rem;

	:deep(.v-chip__content) {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
}
</style>
